import { Text } from "@zapier/design-system";
import styles from "./UnlinkedStatusIndicator.module.css";

export function UnlinkedStatusIndicator() {
  return (
    <div className={styles.root} aria-label="Asset is unlinked">
      <Text color="TextWeakest" type="SmallPrint3Multiline">
        Unlinked
      </Text>
    </div>
  );
}
